import { Component, OnInit, OnDestroy } from '@angular/core';
import { Company, Building, Icons, User, UserType } from 'toolbandi-ui-lib';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService, CrudService, MessageService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BuildingEditComponent } from '../building-edit/building-edit.component';

@Component({
	selector: 'app-building-view',
	templateUrl: './building-view.component.html',
	styleUrls: ['./building-view.component.scss']
})
export class BuildingViewComponent implements OnInit, OnDestroy {

	company: Company;
	loading: boolean = false;
	building: Building;
	breadcrumb: any;

	error: boolean;


	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private buildingService: CrudService<Building>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private companyService: CrudService<Company>
	) {


	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
		});
	}

	load(id: number): void {
		this.loading = true;
		this.buildingService.getEntity(Building, 'building', id).subscribe(building => {
			this.building = building;
			this.error = false;
			if (this.building) {
				this.companyService.getEntity(Company, 'company', this.building.companyid).subscribe(company => {
					this.company = company;
					this.loading = false;
					this.setBreadcrumb();
				});
			} else {
				this.error = true;
				this.loading = false;
			}


		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.building'));
			this.building = undefined;
			this.loading = false;
			this.error = true;
		});

	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.company.name, url: '/company/view/' + this.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
		];
		this.breadcrumb.title = { title: 'labels.view-building', param: this.building.name, icon: Icons.BUILDING, icontooltip: 'labels.building' };
	}

	edit() {
		const modal = this.modalService.open(BuildingEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.companyid = this.building.companyid;
		modal.componentInstance.load(this.building.id);

		modal.result.then((newItem: Building) => {
			this.load(this.building.id);
		}).catch(() => {});
	}



}
